import { render } from "./FormRadioFieldComponent.vue?vue&type=template&id=13503758&scoped=true"
import script from "./FormRadioFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormRadioFieldComponent.vue?vue&type=script&lang=js"

import "./FormRadioFieldComponent.vue?vue&type=style&index=0&id=13503758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13503758"]])

export default __exports__